import * as types from "./types";
import { get, post } from "@zendesk/knowledge-http-client";
import t from "@zendesk/client-i18n-tools";
import { showError } from "@zendesk/knowledge-redux/lib/actions/NotificationActions";
import { getCurrentBrandId, getCSRFToken } from "@zendesk/knowledge-context";
import {
  getItemAbove,
  getItemBelow,
  isMovingDown,
} from "../../utils/positioning";

function fetchSectionsRequest() {
  return {
    type: types.FETCH_CATEGORY_SECTIONS_REQUEST,
  };
}

function fetchSectionsSuccess(sections, page, pageCount, count) {
  return {
    type: types.FETCH_CATEGORY_SECTIONS_SUCCESS,
    sections,
    page,
    pageCount,
    count,
  };
}

function fetchSectionsFailure(error) {
  return {
    type: types.FETCH_CATEGORY_SECTIONS_FAILURE,
    error: true,
    payload: error,
  };
}

export function fetchSections(categoryId, { page }) {
  return (dispatch, getState) => {
    dispatch(fetchSectionsRequest());

    return get(
      `/hc/api/internal/arrange_articles/categories/${categoryId}/sections?multibrand=true&brand_id=${getCurrentBrandId()}&page=${page}&per_page=30`
    )
      .then(({ sections, page, page_count, count }) =>
        dispatch(fetchSectionsSuccess(sections, page, page_count, count))
      )
      .catch(err => {
        dispatch(fetchSectionsFailure(err));
      });
  };
}

function fetchCategoryRequest() {
  return {
    type: types.FETCH_CATEGORY_REQUEST,
  };
}

function fetchCategorySuccess(category) {
  return {
    type: types.FETCH_CATEGORY_SUCCESS,
    category,
  };
}

function fetchCategoryFailure(error) {
  return {
    type: types.FETCH_CATEGORY_FAILURE,
    error: true,
    payload: error,
  };
}

export function fetchCategory(id, sectionPage) {
  return (dispatch, getState) => {
    dispatch(fetchCategoryRequest());

    return get(
      `/hc/api/internal/arrange_articles/categories/${id}?multibrand=true&brand_id=${getCurrentBrandId()}`
    )
      .then(({ category }) => {
        dispatch(fetchSections(id, { page: sectionPage }));
        dispatch(fetchCategorySuccess(category));
      })
      .catch(err => {
        dispatch(fetchCategoryFailure(err));
      });
  };
}

function positionSectionRequest(sourceIndex, destinationIndex) {
  return {
    type: types.POSITION_CATEGORY_SECTION_REQUEST,
    sourceIndex,
    destinationIndex,
  };
}

function positionSectionSuccess(sourceIndex, destinationIndex) {
  return {
    type: types.POSITION_CATEGORY_SECTION_SUCCESS,
    sourceIndex,
    destinationIndex,
  };
}

function positionSectionFailure(sourceIndex, destinationIndex, error) {
  return {
    type: types.POSITION_CATEGORY_SECTION_FAILURE,
    error: true,
    payload: error,
    sourceIndex,
    destinationIndex,
  };
}

export function positionSection(
  categoryId,
  positionedSectionId,
  sourceIndex,
  destinationIndex
) {
  return (dispatch, getState) => {
    const {
      sections: { list },
    } = getState();

    let payload = {
      positioned_section_id: positionedSectionId,
    };

    if (isMovingDown(sourceIndex, destinationIndex)) {
      const item = getItemAbove(list, sourceIndex, destinationIndex);
      payload.below_id = item && item.id;
    } else {
      const item = getItemBelow(list, sourceIndex, destinationIndex);
      payload.above_id = item && item.id;
    }

    dispatch(positionSectionRequest(sourceIndex, destinationIndex));

    return post(
      `/hc/api/internal/arrange_articles/categories/${categoryId}/position_section?multibrand=true&brand_id=${getCurrentBrandId()}`,
      payload,
      {
        csrfToken: getCSRFToken(),
      }
    )
      .then(() => {
        dispatch(positionSectionSuccess(sourceIndex, destinationIndex));
      })
      .catch(err => {
        dispatch(positionSectionFailure(sourceIndex, destinationIndex, err));
        dispatch(
          showError(
            t("knowledge-arrange.notification.sectionPositioned.failure")
          )
        );
      });
  };
}

function moveSectionToTopRequest(sourceIndex) {
  return {
    type: types.MOVE_CATEGORY_SECTION_TO_TOP_REQUEST,
    sourceIndex,
  };
}

function moveSectionToTopSuccess(sourceIndex) {
  return {
    type: types.MOVE_CATEGORY_SECTION_TO_TOP_SUCCESS,
    sourceIndex,
  };
}

function moveSectionToTopFailure(sourceIndex, item, error) {
  return {
    type: types.MOVE_CATEGORY_SECTION_TO_TOP_FAILURE,
    error: true,
    payload: error,
    sourceIndex,
    item,
  };
}

export function moveSectionToTop(movedSection, sourceIndex) {
  return (dispatch, getState) => {
    const { category } = getState();

    dispatch(moveSectionToTopRequest(sourceIndex));

    return post(
      `/hc/api/internal/arrange_articles/categories/${
        category.id
      }/position_section?multibrand=true&brand_id=${getCurrentBrandId()}`,
      {
        positioned_section_id: movedSection.id,
        below_id: null,
      },
      {
        csrfToken: getCSRFToken(),
      }
    )
      .then(() => {
        dispatch(moveSectionToTopSuccess(sourceIndex));
      })
      .catch(err => {
        dispatch(moveSectionToTopFailure(sourceIndex, movedSection, err));
        dispatch(
          showError(
            t("knowledge-arrange.notification.sectionPositioned.failure")
          )
        );
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/category/index.js